import { useEffect } from "react";

import { tenantType } from "@atlassiansox/analytics-web-client";

import { useAnalyticsClient } from "../../../../../../../../analytics/wac-analytics";
import { useCloudStatus } from "../../hooks";

export const AnalyticsClientUpdater = () => {
    const { cloudId } = useCloudStatus();
    const analyticsClient = useAnalyticsClient();

    useEffect(() => {
        if (!analyticsClient || !cloudId) {
            return;
        }

        analyticsClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
    }, [analyticsClient, cloudId]);

    return null;
};
